import { jsx as L } from "react/jsx-runtime";
import { useContext as l } from "react";
import { LocaleProvider as u, getLocaleByLanguageCode as t, LocaleContext as m } from "@systemeio/ui";
import { useStore as n } from "../store/index.mjs";
const v = ({
  i18n: o,
  loadLangBundle: c,
  children: s,
  languageCode: a,
  onChange: e
}) => {
  const { setLocale: i } = n();
  return /* @__PURE__ */ L(
    u,
    {
      languageCode: a,
      i18n: o,
      loadLangBundle: c,
      onChange: (r) => {
        e == null || e(r), i(t(r));
      },
      children: s
    }
  );
}, P = () => {
  const o = l(m);
  if (!o)
    throw new Error("useLocaleContext must be used within a LocaleProvider");
  return { locale: t(o.currentLanguageCode), ...o };
};
export {
  v as LocaleProvider,
  P as useLocaleContext
};
